import React from 'react';
import { ROUNDING_OPTIONS } from '../../adapters';

const DisplayTab = ({ field, readOnly, onChange }) => (
  <div className="ra-tpl-tab-body">
    <div className="ra-tpl-check-grid">
      <label><input type="checkbox" disabled={readOnly} checked={field.editable !== false} onChange={(e) => onChange({ editable: e.target.checked })} /> Editable</label>
      <label><input type="checkbox" disabled={readOnly} checked={field.visible !== false} onChange={(e) => onChange({ visible: e.target.checked })} /> Visible</label>
      <label><input type="checkbox" disabled={readOnly} checked={field.printVisible !== false} onChange={(e) => onChange({ printVisible: e.target.checked })} /> Print</label>
      <label><input type="checkbox" disabled={readOnly} checked={Boolean(field.required)} onChange={(e) => onChange({ required: e.target.checked })} /> Required</label>
      <label><input type="checkbox" disabled={readOnly} checked={Boolean(field.allowOverride)} onChange={(e) => onChange({ allowOverride: e.target.checked })} /> Allow Override</label>
    </div>
    <div className="form-row">
      <div className="form-group">
        <label>Rounding</label>
        <select disabled={readOnly} value={field.roundingMethod || 'ROUND'} onChange={(e) => onChange({ roundingMethod: e.target.value })}>
          {ROUNDING_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div className="form-group">
        <label>Decimal places</label>
        <input disabled={readOnly} type="number" min="0" max="4" value={field.decimalPlaces ?? 0} onChange={(e) => onChange({ decimalPlaces: Number(e.target.value) || 0 })} />
      </div>
    </div>
    <div className="form-row">
      <div className="form-group">
        <label>Min</label>
        <input disabled={readOnly} type="number" value={field.minValue ?? ''} onChange={(e) => onChange({ minValue: e.target.value === '' ? null : Number(e.target.value) })} />
      </div>
      <div className="form-group">
        <label>Max</label>
        <input disabled={readOnly} type="number" value={field.maxValue ?? ''} onChange={(e) => onChange({ maxValue: e.target.value === '' ? null : Number(e.target.value) })} />
      </div>
    </div>
  </div>
);

export default DisplayTab;
